import * as React from 'react'
import { NumberPicker } from '@alifd/next';
import { useAppDispatch } from '../../redux/hooks';
import { setInfoNumber } from '../../redux/reduces/skuSlice';
import doLog from '../../common/log';
import './sku-none.scss'

const {useState, useEffect} = React;

export default function SkuNone(props: any) {
  const {i18n, moq, inventory, price} = props;
  let maxCount = 99999;
  if (inventory) {
    const {preferedDispatchId, repoSkuInventory} = inventory;
    const {skuMap} = repoSkuInventory[preferedDispatchId] || {};
    maxCount = skuMap[-1]?.inventoryCount > -1 ? skuMap[-1]?.inventoryCount : 99999;
  }
  
  const [value, setValue] = useState(moq);
  const dispatch = useAppDispatch();
  
  // 默认最小moq
  useEffect(() => {
    dispatch(setInfoNumber({
      isSoldOut: moq > maxCount,
      number: moq
    }))
  }, []);
  
  return (
    <div className='sku-none'>
      <label>{i18n["pc.detail.sku.quality"]}</label>
      <div className='sku-number'>
        <NumberPicker value={value} style={{
          width: 120
        }} onChange={number => {
          doLog('/sc.details.wsSkuNumberClick');
          setValue(number)
          dispatch(setInfoNumber({
            number
          }))
        }} min={moq} onBlur={() => {
          // 按批采购
          if (price?.batchNum) {
            if (value % price.batchNum > 0 ) {
              setValue(value - value % price.batchNum);
            }
          }
        }} max={maxCount} type="inline" step={price?.batchNum || 1}/>
        <span>{price?.unitEven}</span>
      </div>
    </div>
  )
}
